export const AVATAR_FORMAT = "image/jpg, image/jpeg, image/png";

export const CONTENT_IMAGE_FORMAT = "image/jpg, image/jpeg, image/png";
export const CONTENT_PDF_FORMAT = "application/pdf";
export const POST_CONTENT_FORMATS = {
  "image/*": [".jpg", ".jpeg", ".png"],
  "video/*": [".mp4", ".quicktime"],
  "audio/*": [".mpeg", ".wav", ".aac"],
};
